import React from 'react'
import { Outlet} from 'react-router-dom'

export default function Finance() {
  return (
    <div className="d-flex flex-column">
      <Outlet />
    </div>
  )
}